// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Divider, Grid, Typography} from '@material-ui/core';
import CustomButton from '../CustomButton/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomModal from '../CustomModal/CustomModal';
import {colors} from '../../assets/styles/colors';
import {Link} from 'react-router-dom';

import desktopFree from '../../assets/img/desktopFree.png';
import desktopPro from '../../assets/img/desktopPro.png';

type Props = {
  open: boolean,
  handleClose: () => void,
};
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 850,
    padding: theme.spacing(4, 1, 2, 1),
    overflowX: 'hidden',
  },
  title: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '20px',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      fontSize: '24px',
    },
  },
  description: {
    textAlign: 'center',
    fontSize: '0.875rem',
    color: colors.grey800,
  },
  innerContent: {
    // marginTop: theme.spacing(3),
    padding: theme.spacing(2, 4),
    borderRadius: '12px',
    // backgroundColor: colors.grey200,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  regularPrice: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
    fontSize: '0.875rem',
    fontWeight: 500,
    color: colors.grey700,
  },
  descFreeTrial: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
    fontSize: '16px',
    color: colors.grey700,
  },
  tryFree: {
    textAlign: 'center',
    marginTop: theme.spacing(3),
    fontSize: '0.875rem',
    fontWeight: 500,
    color: colors.purple3,
  },
  upsellMessage: {
    textAlign: 'center',
    width: 272,
    marginTop: theme.spacing(2),
    fontWeight: 600,
  },
  featureList: {
    textAlign: 'center',
    lineHeight: '24px',
    marginTop: theme.spacing(2),
    fontSize: '0.75rem',
    color: colors.grey800,
  },
  button: {
    height: 40,
    marginTop: theme.spacing(2),
    fontSize: '1rem',
    fontWeight: 600,
    padding: '6px 50px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  whatUCanDo: {
    backgroundColor: colors.grey200,
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
  },
  whatUCanDoText: {
    color: colors.grey900,
    fontSize: '14px',
    fontWeight: 600,
  },
  verticalDivider: {
    backgroundColor: colors.grey300,
    height: '2rem',
    margin: theme.spacing(0, 2),
  },
  disclaimer: {
    color: colors.grey700,
    fontSize: '12px',
  },
  horizontalDivider: {
    width: '100%',
    margin: theme.spacing(2, 0),
  },
  imgStar: {
    width: '4rem',
  },

  cardTier: {
    width: '100%',
    height: '100%',
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      border: '1px solid #E8E8ED',
      boxShadow: '0px 0px 1px rgba(181, 181, 181, 0.2)',
      borderRadius: '10px',
    },
  },
  tierFree: {
    backgroundColor: '#BDEADE',
    color: '#03946D',
    borderRadius: '20px',
    padding: '4px 11px',
    fontSize: '0.75rem',
    fontWeight: 500,
  },
  tierPro: {
    backgroundColor: '#FDAC42',
    color: '#A55903',
    borderRadius: '20px',
    padding: '4px 11px',
    fontSize: '0.75rem',
    fontWeight: 500,
  },
  tierTitle: {
    color: '#313135',
    fontSize: '24px',
    fontWeight: 600,
  },
  tierDesc: {
    textAlign: 'center',
    color: '#55556D',
    fontSize: '14px',
  },
  cardGray: {
    width: '100%',
    height: '100%',
    margin: '1rem 0',
    background: '#F3F3F6',
    padding: theme.spacing(2, 1),
    borderRadius: '10px',
  },
  containerTiers: {
    border: '1px solid #E8E8ED',
    margin: '1rem 0',
    boxShadow: '0px 0px 1px rgba(181, 181, 181, 0.2)',
    borderRadius: '10px',
    [theme.breakpoints.down('md')]: {
      border: 'none',
    },
  },
  wrapperImg: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  ulDesc: {
    '& li': {
      color: '#7B39FF',
      fontSize: '14px',
      margin: '2px 0',
    },
    '& li span': {
      color: '#3A3A49!important',
    },
  },
  bold: {
    fontWeight: 600,
    color: '#3A3A49',
  },
}));

export default function ComparisonTierModal(props: Props) {
  const {open, handleClose} = props;
  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <Typography className={classes.title}>
          ¡Te contamos más acerca de nuestros planes!
        </Typography>
        <Divider className={classes.divider} />

        <Grid container spacing={2} className={classes.containerTiers}>
          <Grid item xs={12} md={6}>
            <div className={classes.cardTier}>
              <div className={classes.tierFree}>GRATIS</div>
              <Typography className={classes.tierTitle}>TiendaDa</Typography>
              <Typography className={classes.tierDesc}>
                Si estás iniciando con tu emprendimiento, esta versión es para
                ti.
              </Typography>

              <div className={classes.cardGray}>
                <div className={classes.wrapperImg}>
                  <img src={desktopFree} alt="tiendada free" />
                </div>

                <ul className={classes.ulDesc}>
                  <li>
                    <span>Catálogo web con carrito de compras. </span>
                  </li>
                  <li>
                    <span>Recibes los pedidos en WhatsApp. </span>
                  </li>
                  <li>
                    <span className={classes.bold}>
                      SIMPLE, FÁCIL, GRATIS.{' '}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className={classes.cardTier}>
              <div className={classes.tierPro}>PLAN PRO</div>
              <Typography className={classes.tierTitle}>
                TiendaDa Pro
              </Typography>
              <Typography className={classes.tierDesc}>
                Tienda virtual con configuraciones avanzadas de producto y
                herramientas de gestión.
              </Typography>

              <div className={classes.cardGray}>
                <div className={classes.wrapperImg}>
                  <img src={desktopPro} alt="tiendada pro" />
                </div>

                <ul className={classes.ulDesc}>
                  <li>
                    <span>
                      Herramientas de promoción de ventas: cupones de descuento,
                      precios al por mayor, promociones.
                    </span>
                  </li>
                  <li>
                    <span>
                      Herramientas de gestión: automatización de correos,
                      inventarios, pedidos, ingresos y data de cliente.
                    </span>
                  </li>
                  <li>
                    <span>Diseño responsive y personalización.</span>
                  </li>
                </ul>

                {/* <Divider className={classes.divider} />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0.5rem 0',
                  }}
                >
                  <CustomButton>Ver comparación a detalle</CustomButton>
                </div> */}
              </div>
            </div>
          </Grid>
        </Grid>

        <CustomButton
          variant="contained"
          className={classes.button}
          component={Link}
          to="/tiers-list"
        >
          Ver planes
        </CustomButton>
      </div>
    </CustomModal>
  );
}

ComparisonTierModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
